export const SERVER_RESPONSE_CODES = {
    BAD_REQUEST: 400,
    CONFLICT: 409,
    CREATED: 201,
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500,
    NOT_FOUND: 404,
    OK: 200,
    UNAUTHORIZED: 401,
} as const;

type ServerResponseKeys = keyof typeof SERVER_RESPONSE_CODES;
export type ServerResponseCodesType =
    (typeof SERVER_RESPONSE_CODES)[ServerResponseKeys];
